import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { AllocationViewActionIdentifierModel, AllocationViewSecurityFinishedModel } from '../../models';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AllocationViewFinishArrivalSecurityActionService {
  constructor(private http: WrapperHttpService) {}

  arrivalSecurityFinishPrepare(
    actionIdentifier: AllocationViewActionIdentifierModel,
    currentLanguage: string,
  ): Observable<AllocationViewSecurityFinishedModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.ArrivalSecurityFinished}${AllocationViewEndpoint.Prepare}?lang=${currentLanguage}`;

    return this.http.withLoading().post<AllocationViewSecurityFinishedModel>(url, actionIdentifier);
  }

  arrivalSecurityFinish(data: AllocationViewSecurityFinishedModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.ArrivalSecurityFinished}`;
    return this.http.withLoading().post<void>(url, data);
  }
}
